import AbsComponent from '../../common/components/AbsComponent';

class BannerDday extends AbsComponent{
	constructor(_store={}, _el=''){
		super(_store, _el);
		this.render();
	}

	render() {

		// console.log( $(this.el).length );

		if( $(this.el).length === 0){
			return false;
		}
		if(window._device === 'ingame' || window._device === 'launcher'){
			$(this.el).hide();
			return false;
		}

		const ddayNum = $(this.el)[0].getAttribute('data-dday');
		const dday = new Date(parseInt(ddayNum.substring(0,4)), parseInt(ddayNum.substring(4,6))-1, parseInt(ddayNum.substring(6,8)));
		const dayNow = new Date(window.userData.now); // 2019-12-09T13:31:56.818+09:00
		// const dayNow = new Date();

		// console.log(dday.getTime() , dayNow.getTime() );

		const timeDiff = dday.getTime() - dayNow.getTime();
		const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

		if(dayDiff<0){
			$(this.el).hide();
		}
		else if(dayDiff === 0){
			$(this.el + ' .banner-date-num').text("DAY");
			$(this.el).show();
		}
		else{
			$(this.el + ' .banner-date-num').text(dayDiff);
			$(this.el).show();
		}

	}

}

export default BannerDday;
/**
 * UserState class
 * @category mainApp
 */